import { boolean, number, object, string } from '@gogame/schemas';

import {
  ACCOUNT,
  CREDENTIALS,
  DATA_TYPE,
  IS_AUTO_SYNC,
  NAME,
  PARTNER,
  PARTNER_API_ID,
} from 'scenes/CustomAudiences/PartnerAudiences/components/PartnerAudienceForm/constants';
import { BING } from 'scenes/CustomAudiences/constants';

export const validationSchema = object({
  [PARTNER_API_ID]: string().required('Id is required').default(''),
  [PARTNER]: number().required('Partner is required').default(BING),
  [IS_AUTO_SYNC]: boolean().default(true),
  [NAME]: string().required('Name is required').default(''),
  [CREDENTIALS]: number().required('Credentials is required'),
  [DATA_TYPE]: number().required('Data type is required').default(2),
  [ACCOUNT]: string().required('Account is required'),
});
